import React from 'react';

// Chat Icon SVG component
export const ChatIcon = ({ color = 'white' }: { color?: string }) => (
  <svg 
    width="32" 
    height="30" 
    viewBox="0 0 32 32" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur stdDeviation="1" result="blur" />
        <feComposite in="SourceGraphic" in2="blur" operator="over" />
      </filter>
    </defs>
    <g filter="url(#glow)">
      <path 
        d="M26.667 21.333C26.667 22.040 26.386 22.717 25.886 23.217C25.386 23.718 24.708 24 24 24H10.667L5.333 29.333V10.667C5.333 9.959 5.614 9.282 6.114 8.781C6.614 8.281 7.292 8 8 8H24C24.708 8 25.386 8.281 25.886 8.781C26.386 9.282 26.667 9.959 26.667 10.667V21.333Z" 
        stroke={color} 
        strokeWidth="2.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="rgba(255, 255, 255, 0.1)"
      />
      <circle cx="10.667" cy="16" r="1.333" fill={color}>
        <animate attributeName="opacity" values="0.7;1;0.7" dur="2s" repeatCount="indefinite" />
      </circle>
      <circle cx="16" cy="16" r="1.333" fill={color}>
        <animate attributeName="opacity" values="0.7;1;0.7" dur="2s" begin="0.3s" repeatCount="indefinite" />
      </circle>
      <circle cx="21.333" cy="16" r="1.333" fill={color}>
        <animate attributeName="opacity" values="0.7;1;0.7" dur="2s" begin="0.6s" repeatCount="indefinite" />
      </circle>
    </g>
  </svg>
);

// Close Icon SVG component
export const CloseIcon = ({ color = 'white' }: { color?: string }) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 8L8 24M8 8L24 24" 
      stroke={color} 
      strokeWidth="2.5" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
    />
  </svg>
);

// Close Button Icon SVG component
export const CloseButtonIcon = ({ color = 'currentColor' }: { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18M6 6L18 18" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
    />
  </svg>
);

// Send Button Icon SVG component
export const SendButtonIcon = ({ color = 'currentColor' }: { color?: string }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
    />
  </svg>
); 